import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState, useEffect, useRef, useMemo } from "preact/hooks"

export default function RangeFacet({ facet, expandedFacet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);
    const isSelected = min !== range[0] || max !== range[1];
    const [ active, setActive ] = useState(false);
    const facetLabel = useMemo(() => facet.field.replaceAll('.', '-').replaceAll(' ', '-'), []);

    const [ dropdownHeight, setDropdownHeight ] = useState(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if(window.innerWidth >= 1024 && expandedFacet === facetLabel) {
            setActive(true);
        }
        return () => setActive(false)
    }, [ expandedFacet ])

    useEffect(() => {
        if(dropdownRef?.current) {
            setDropdownHeight(dropdownRef.current.offsetHeight);
        }
    }, [ dropdownRef, facet ]);

    const toggleActive = () => {
        setActive(prevActive => !prevActive)
    }

    return (
        <li class={`ns-facet-dropdown relative px-5 ${active ? "ns-active" : ""}`}>
            <button
                className="ns-facet-body_toggle flex w-full h6--medium block cursor-pointer py-5 relative after:block after:absolute after:duration-700 after:border-gray-900 after:right-7 after:top-1/2 after:-translate-y-1/2 after:border-b after:w-2 after:h-2 after:border-l after:-rotate-45 after:origin-center"
                type="button"
                data-nosto-element="facet"
                aria-controls={`ns-facet-${facetLabel}`}
                aria-label={`Expand ${facet.name} filter options`}
                aria-expanded={active}
                onClick={toggleActive}
                tabIndex="0"
            >
                {facet.name}
                {isSelected && (
                    <span className="ml-1 !bg-transparent !shadow-none">
                        (1)
                    </span>
                )}
            </button>
            <div 
                className="ns-facet-body"
                style={`--dropdown-height: ${dropdownHeight}px;`}
                id={`ns-facet-${facetLabel}`}
                aria-hidden={!active}
                aria-labelledby={`ns-facet-heading-${facetLabel}`}
                role="region"
            >
                <div
                    className="flex flex-col w-full px-2 pb-5"
                    ref={dropdownRef}
                >
                    <div className="flex gap-2">
                        <h4
                            className="visually-hidden sr-only"
                            id={`ns-facet-heading-${facetLabel}`} 
                        >
                            Filter options for {facet.name}
                        </h4>
                        <div className="w-1/2">
                            <label for={`ns-${facet.id}-min`}>
                                Min.
                            </label>
                            <input 
                                className="block w-full"
                                type="number" 
                                id={`ns-${facet.id}-min`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[0]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <div className="w-1/2">
                            <label for={`ns-${facet.id}-max`}>
                                Max.
                            </label>
                            <input 
                                className="block w-full"
                                type="number" 
                                id={`ns-${facet.id}-max`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[1]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>
                    <RangeSlider className="ns-range-slider relative z-1" id={facet.id} />
                </div>
            </div>
        </li>
    )
}
